import { Button } from "@drs-ops/ui";
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import type { AirportResult } from "@/types/tripPlanner";

export interface DeltaAirportCardProps {
  airports: AirportResult[];
}

export function DeltaAirportCard({ airports }: DeltaAirportCardProps): React.ReactElement {
  const [expanded, setExpanded] = useState(false);
  const primary = airports[0];
  const rest = airports.slice(1);
  if (!primary) return <></>;
  return (
    <Card>
      <CardContent className="flex flex-col gap-2 p-4">
        <div className="font-semibold">Nearest Delta airport</div>
        <div className="text-sm">
          <span className="font-mono">{primary.iata}</span> — {primary.name}, {primary.city}, {primary.state} (
          {primary.distance_miles_from_venue.toFixed(1)} mi)
        </div>
        {rest.length > 0 && !expanded && (
          <Button variant="ghost" size="sm" className="self-start" onClick={() => setExpanded(true)}>
            + show next {rest.length}
          </Button>
        )}
        {expanded && rest.length > 0 && (
          <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
            {rest.map((a) => (
              <li key={a.iata}>
                <span className="font-mono">{a.iata}</span> — {a.name}, {a.city}, {a.state} (
                {a.distance_miles_from_venue.toFixed(1)} mi)
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
